import { useEffect, useState } from "react";
import { Location, useLocation } from "react-router-dom";

import { isModalRoute } from "../helpers/routes";

const scrollExcludeList = ["/vehicle-search"];

const ScrollToTop = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState(
    null as Location<unknown> | null
  );

  useEffect(() => {
    const isScrollExcluded = scrollExcludeList.find((path) =>
      location.pathname.endsWith(path)
    );
    if (
      !isModalRoute(location) &&
      (!prevLocation || !isModalRoute(prevLocation)) &&
      !isScrollExcluded
    ) {
      window.scrollTo(0, 0);
    }
    setPrevLocation(location);
  }, [location]);

  return null;
};

export default ScrollToTop;
